/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddDeliveryProofDto } from '../model';
// @ts-ignore
import type { AddDeliveryProofResponseDto } from '../model';
// @ts-ignore
import type { ChallengeForDropdownDto } from '../model';
// @ts-ignore
import type { ConfirmDeliveryResponseDto } from '../model';
// @ts-ignore
import type { EntitlementsSummaryResponseDto } from '../model';
// @ts-ignore
import type { GetDeliveryResponseDto } from '../model';
// @ts-ignore
import type { PaginatedDeliveriesResponseDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryDestinationDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryDestinationResponseDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryOriginDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryOriginResponseDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryStatusDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryStatusResponseDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryTrackingDto } from '../model';
// @ts-ignore
import type { UpdateDeliveryTrackingResponseDto } from '../model';
/**
 * DeliveriesApi - axios parameter creator
 * @export
 */
export const DeliveriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add delivery proof images
         * @param {string} id Delivery ID
         * @param {AddDeliveryProofDto} addDeliveryProofDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerAddDeliveryProof: async (id: string, addDeliveryProofDto: AddDeliveryProofDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerAddDeliveryProof', 'id', id)
            // verify required parameter 'addDeliveryProofDto' is not null or undefined
            assertParamExists('deliveriesControllerAddDeliveryProof', 'addDeliveryProofDto', addDeliveryProofDto)
            const localVarPath = `/api/deliveries/{id}/proof`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDeliveryProofDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm delivery by user
         * @param {string} id Delivery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerConfirmDelivery: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerConfirmDelivery', 'id', id)
            const localVarPath = `/api/deliveries/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated deliveries with optional filters (admin/organizer)
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search by contact number, name, challenge title, or delivery ID (partial match)
         * @param {string} [contactNumber] Search by contact number (partial match)
         * @param {DeliveriesControllerFindAllPaginatedStatusEnum} [status] Filter by delivery status
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {string} [eventId] Filter by event/challenge ID
         * @param {string} [shirtSize] Filter by finisher shirt size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindAllPaginated: async (page?: number, limit?: number, search?: string, contactNumber?: string, status?: DeliveriesControllerFindAllPaginatedStatusEnum, organizerId?: string, eventId?: string, shirtSize?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deliveries/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (contactNumber !== undefined) {
                localVarQueryParameter['contactNumber'] = contactNumber;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (organizerId !== undefined) {
                localVarQueryParameter['organizerId'] = organizerId;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }

            if (shirtSize !== undefined) {
                localVarQueryParameter['shirtSize'] = shirtSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all deliveries by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindDeliveriesByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deliveriesControllerFindDeliveriesByUserId', 'userId', userId)
            const localVarPath = `/api/deliveries/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single delivery by ID
         * @param {string} id Delivery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindDelivery: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerFindDelivery', 'id', id)
            const localVarPath = `/api/deliveries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get delivery by participation ID
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindDeliveryByParticipationId: async (participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('deliveriesControllerFindDeliveryByParticipationId', 'participationId', participationId)
            const localVarPath = `/api/deliveries/participation/{participationId}`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get challenges for delivery filter dropdown (admin/organizer)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerGetChallengesForDropdown: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deliveries/challenges-for-dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get entitlements summary for a specific event (admin/organizer)
         * @param {string} eventId Event/Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerGetEntitlementsSummary: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deliveriesControllerGetEntitlementsSummary', 'eventId', eventId)
            const localVarPath = `/api/deliveries/entitlements-summary/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update delivery destination information using an address ID
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryDestinationDto} updateDeliveryDestinationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryDestination: async (id: string, updateDeliveryDestinationDto: UpdateDeliveryDestinationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryDestination', 'id', id)
            // verify required parameter 'updateDeliveryDestinationDto' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryDestination', 'updateDeliveryDestinationDto', updateDeliveryDestinationDto)
            const localVarPath = `/api/deliveries/{id}/destination`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryDestinationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update delivery origin information
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryOriginDto} updateDeliveryOriginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryOrigin: async (id: string, updateDeliveryOriginDto: UpdateDeliveryOriginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryOrigin', 'id', id)
            // verify required parameter 'updateDeliveryOriginDto' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryOrigin', 'updateDeliveryOriginDto', updateDeliveryOriginDto)
            const localVarPath = `/api/deliveries/{id}/origin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryOriginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update delivery status
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryStatusDto} updateDeliveryStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryStatus: async (id: string, updateDeliveryStatusDto: UpdateDeliveryStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryStatus', 'id', id)
            // verify required parameter 'updateDeliveryStatusDto' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryStatus', 'updateDeliveryStatusDto', updateDeliveryStatusDto)
            const localVarPath = `/api/deliveries/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update delivery tracking information
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryTrackingDto} updateDeliveryTrackingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryTracking: async (id: string, updateDeliveryTrackingDto: UpdateDeliveryTrackingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryTracking', 'id', id)
            // verify required parameter 'updateDeliveryTrackingDto' is not null or undefined
            assertParamExists('deliveriesControllerUpdateDeliveryTracking', 'updateDeliveryTrackingDto', updateDeliveryTrackingDto)
            const localVarPath = `/api/deliveries/{id}/tracking`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryTrackingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveriesApi - functional programming interface
 * @export
 */
export const DeliveriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add delivery proof images
         * @param {string} id Delivery ID
         * @param {AddDeliveryProofDto} addDeliveryProofDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerAddDeliveryProof(id: string, addDeliveryProofDto: AddDeliveryProofDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddDeliveryProofResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerAddDeliveryProof(id, addDeliveryProofDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerAddDeliveryProof']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm delivery by user
         * @param {string} id Delivery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerConfirmDelivery(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmDeliveryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerConfirmDelivery(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerConfirmDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated deliveries with optional filters (admin/organizer)
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search by contact number, name, challenge title, or delivery ID (partial match)
         * @param {string} [contactNumber] Search by contact number (partial match)
         * @param {DeliveriesControllerFindAllPaginatedStatusEnum} [status] Filter by delivery status
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {string} [eventId] Filter by event/challenge ID
         * @param {string} [shirtSize] Filter by finisher shirt size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerFindAllPaginated(page?: number, limit?: number, search?: string, contactNumber?: string, status?: DeliveriesControllerFindAllPaginatedStatusEnum, organizerId?: string, eventId?: string, shirtSize?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDeliveriesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerFindAllPaginated(page, limit, search, contactNumber, status, organizerId, eventId, shirtSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerFindAllPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all deliveries by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerFindDeliveriesByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDeliveryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerFindDeliveriesByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerFindDeliveriesByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single delivery by ID
         * @param {string} id Delivery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerFindDelivery(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDeliveryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerFindDelivery(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerFindDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get delivery by participation ID
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerFindDeliveryByParticipationId(participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDeliveryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerFindDeliveryByParticipationId(participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerFindDeliveryByParticipationId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get challenges for delivery filter dropdown (admin/organizer)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerGetChallengesForDropdown(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChallengeForDropdownDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerGetChallengesForDropdown(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerGetChallengesForDropdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get entitlements summary for a specific event (admin/organizer)
         * @param {string} eventId Event/Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerGetEntitlementsSummary(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntitlementsSummaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerGetEntitlementsSummary(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerGetEntitlementsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update delivery destination information using an address ID
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryDestinationDto} updateDeliveryDestinationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerUpdateDeliveryDestination(id: string, updateDeliveryDestinationDto: UpdateDeliveryDestinationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDeliveryDestinationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerUpdateDeliveryDestination(id, updateDeliveryDestinationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerUpdateDeliveryDestination']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update delivery origin information
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryOriginDto} updateDeliveryOriginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerUpdateDeliveryOrigin(id: string, updateDeliveryOriginDto: UpdateDeliveryOriginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDeliveryOriginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerUpdateDeliveryOrigin(id, updateDeliveryOriginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerUpdateDeliveryOrigin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update delivery status
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryStatusDto} updateDeliveryStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerUpdateDeliveryStatus(id: string, updateDeliveryStatusDto: UpdateDeliveryStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDeliveryStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerUpdateDeliveryStatus(id, updateDeliveryStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerUpdateDeliveryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update delivery tracking information
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryTrackingDto} updateDeliveryTrackingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesControllerUpdateDeliveryTracking(id: string, updateDeliveryTrackingDto: UpdateDeliveryTrackingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDeliveryTrackingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesControllerUpdateDeliveryTracking(id, updateDeliveryTrackingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesControllerUpdateDeliveryTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveriesApi - factory interface
 * @export
 */
export const DeliveriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Add delivery proof images
         * @param {string} id Delivery ID
         * @param {AddDeliveryProofDto} addDeliveryProofDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerAddDeliveryProof(id: string, addDeliveryProofDto: AddDeliveryProofDto, options?: RawAxiosRequestConfig): AxiosPromise<AddDeliveryProofResponseDto> {
            return localVarFp.deliveriesControllerAddDeliveryProof(id, addDeliveryProofDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm delivery by user
         * @param {string} id Delivery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerConfirmDelivery(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ConfirmDeliveryResponseDto> {
            return localVarFp.deliveriesControllerConfirmDelivery(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated deliveries with optional filters (admin/organizer)
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search by contact number, name, challenge title, or delivery ID (partial match)
         * @param {string} [contactNumber] Search by contact number (partial match)
         * @param {DeliveriesControllerFindAllPaginatedStatusEnum} [status] Filter by delivery status
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {string} [eventId] Filter by event/challenge ID
         * @param {string} [shirtSize] Filter by finisher shirt size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindAllPaginated(page?: number, limit?: number, search?: string, contactNumber?: string, status?: DeliveriesControllerFindAllPaginatedStatusEnum, organizerId?: string, eventId?: string, shirtSize?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDeliveriesResponseDto> {
            return localVarFp.deliveriesControllerFindAllPaginated(page, limit, search, contactNumber, status, organizerId, eventId, shirtSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all deliveries by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindDeliveriesByUserId(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetDeliveryResponseDto>> {
            return localVarFp.deliveriesControllerFindDeliveriesByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single delivery by ID
         * @param {string} id Delivery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindDelivery(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDeliveryResponseDto> {
            return localVarFp.deliveriesControllerFindDelivery(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get delivery by participation ID
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerFindDeliveryByParticipationId(participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDeliveryResponseDto> {
            return localVarFp.deliveriesControllerFindDeliveryByParticipationId(participationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get challenges for delivery filter dropdown (admin/organizer)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerGetChallengesForDropdown(options?: RawAxiosRequestConfig): AxiosPromise<Array<ChallengeForDropdownDto>> {
            return localVarFp.deliveriesControllerGetChallengesForDropdown(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get entitlements summary for a specific event (admin/organizer)
         * @param {string} eventId Event/Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerGetEntitlementsSummary(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<EntitlementsSummaryResponseDto> {
            return localVarFp.deliveriesControllerGetEntitlementsSummary(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update delivery destination information using an address ID
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryDestinationDto} updateDeliveryDestinationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryDestination(id: string, updateDeliveryDestinationDto: UpdateDeliveryDestinationDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateDeliveryDestinationResponseDto> {
            return localVarFp.deliveriesControllerUpdateDeliveryDestination(id, updateDeliveryDestinationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update delivery origin information
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryOriginDto} updateDeliveryOriginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryOrigin(id: string, updateDeliveryOriginDto: UpdateDeliveryOriginDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateDeliveryOriginResponseDto> {
            return localVarFp.deliveriesControllerUpdateDeliveryOrigin(id, updateDeliveryOriginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update delivery status
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryStatusDto} updateDeliveryStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryStatus(id: string, updateDeliveryStatusDto: UpdateDeliveryStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateDeliveryStatusResponseDto> {
            return localVarFp.deliveriesControllerUpdateDeliveryStatus(id, updateDeliveryStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update delivery tracking information
         * @param {string} id Delivery ID
         * @param {UpdateDeliveryTrackingDto} updateDeliveryTrackingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesControllerUpdateDeliveryTracking(id: string, updateDeliveryTrackingDto: UpdateDeliveryTrackingDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateDeliveryTrackingResponseDto> {
            return localVarFp.deliveriesControllerUpdateDeliveryTracking(id, updateDeliveryTrackingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveriesApi - object-oriented interface
 * @export
 * @class DeliveriesApi
 * @extends {BaseAPI}
 */
export class DeliveriesApi extends BaseAPI {
    /**
     * 
     * @summary Add delivery proof images
     * @param {string} id Delivery ID
     * @param {AddDeliveryProofDto} addDeliveryProofDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerAddDeliveryProof(id: string, addDeliveryProofDto: AddDeliveryProofDto, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerAddDeliveryProof(id, addDeliveryProofDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm delivery by user
     * @param {string} id Delivery ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerConfirmDelivery(id: string, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerConfirmDelivery(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated deliveries with optional filters (admin/organizer)
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search by contact number, name, challenge title, or delivery ID (partial match)
     * @param {string} [contactNumber] Search by contact number (partial match)
     * @param {DeliveriesControllerFindAllPaginatedStatusEnum} [status] Filter by delivery status
     * @param {string} [organizerId] Filter by organizer ID (for internal use)
     * @param {string} [eventId] Filter by event/challenge ID
     * @param {string} [shirtSize] Filter by finisher shirt size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerFindAllPaginated(page?: number, limit?: number, search?: string, contactNumber?: string, status?: DeliveriesControllerFindAllPaginatedStatusEnum, organizerId?: string, eventId?: string, shirtSize?: string, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerFindAllPaginated(page, limit, search, contactNumber, status, organizerId, eventId, shirtSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all deliveries by user ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerFindDeliveriesByUserId(userId: string, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerFindDeliveriesByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single delivery by ID
     * @param {string} id Delivery ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerFindDelivery(id: string, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerFindDelivery(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get delivery by participation ID
     * @param {string} participationId Participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerFindDeliveryByParticipationId(participationId: string, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerFindDeliveryByParticipationId(participationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get challenges for delivery filter dropdown (admin/organizer)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerGetChallengesForDropdown(options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerGetChallengesForDropdown(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get entitlements summary for a specific event (admin/organizer)
     * @param {string} eventId Event/Challenge ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerGetEntitlementsSummary(eventId: string, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerGetEntitlementsSummary(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update delivery destination information using an address ID
     * @param {string} id Delivery ID
     * @param {UpdateDeliveryDestinationDto} updateDeliveryDestinationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerUpdateDeliveryDestination(id: string, updateDeliveryDestinationDto: UpdateDeliveryDestinationDto, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerUpdateDeliveryDestination(id, updateDeliveryDestinationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update delivery origin information
     * @param {string} id Delivery ID
     * @param {UpdateDeliveryOriginDto} updateDeliveryOriginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerUpdateDeliveryOrigin(id: string, updateDeliveryOriginDto: UpdateDeliveryOriginDto, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerUpdateDeliveryOrigin(id, updateDeliveryOriginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update delivery status
     * @param {string} id Delivery ID
     * @param {UpdateDeliveryStatusDto} updateDeliveryStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerUpdateDeliveryStatus(id: string, updateDeliveryStatusDto: UpdateDeliveryStatusDto, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerUpdateDeliveryStatus(id, updateDeliveryStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update delivery tracking information
     * @param {string} id Delivery ID
     * @param {UpdateDeliveryTrackingDto} updateDeliveryTrackingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesControllerUpdateDeliveryTracking(id: string, updateDeliveryTrackingDto: UpdateDeliveryTrackingDto, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesControllerUpdateDeliveryTracking(id, updateDeliveryTrackingDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeliveriesControllerFindAllPaginatedStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;
export type DeliveriesControllerFindAllPaginatedStatusEnum = typeof DeliveriesControllerFindAllPaginatedStatusEnum[keyof typeof DeliveriesControllerFindAllPaginatedStatusEnum];
